module.exports = __webpack_public_path__ + "img/applymanage-active.b778fafa.svg";